import React, { useCallback, useMemo, useState } from 'react'
import { Message, Pagination } from 'rsuite'

import DeliveryZonesSubMenu from '@components/logistic/DeliveryZonesSubMenu'
import LogisticTopMenu from '@components/logistic/LogisticTopMenu'

import './DeliveryZonesPage.scss'
import DeliveryZoneTable from '@components/deliveryZone/table/GeozoneTable'
import DeliveryZonesFilter from '@components/deliveryZone/table/DeliveryZonesFilter'
import { useFetchAllDeliveryZones } from '@@partner:graphql/query/deliveryZone/allDeliveryZones.gql'
import { CommonSort, NestedFilter } from '@@partner:types:graphql'
import { convertToInt } from '@@partner:helpers/util'
import { useParams } from 'react-router-dom'
import { currentBrandVar } from '@@partner:graphql/initial-data'

const ZONES_PER_PAGE = 10

export default function DeliveryZonesPage () {
  const { brandSlug } = useParams<any>()
  const [ page, setPage ] = useState(1)
  const currentBrand = currentBrandVar()
  
  // Базовый фильтр по бренду - всегда применяется
  const baseFilter = useMemo<NestedFilter>(() => ({
    fields: [ 'brand_id' ],
    op: 'eq',
    value: currentBrand?.id
  }), [ currentBrand?.id ])

  const [ filter, setFilter ] = useState<NestedFilter>(baseFilter)
  const [ sort, setSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: 0
  })

  const { data, loading, error } = useFetchAllDeliveryZones({
    pager: {
      page,
      limit: ZONES_PER_PAGE
    },
    filter,
    sort
  })

  const handlePageSelect = useCallback((selectedPage: number | string) => {
    setPage(convertToInt(selectedPage))
  }, [])

  const handleFilterChanged = useCallback((updatedFilter: NestedFilter) => {
    setFilter(updatedFilter)
    setPage(1)
  }, [])

  const handleSortColumn = useCallback((sortColumn, sortType) => {
    setSort({
      fieldName: sortColumn,
      direction: sortType === 'desc' ? 0 : 1
    })
  }, [])

  const deliveryZones = data?.allDeliveryZones.edges ?? []
  const pageInfo = data?.allDeliveryZones.pageInfo

  const showPagination = pageInfo?.lastPage !== 1
  
  
  return (
    <div className="DeliveryZones">
      <h1 className="u-heading">
        Зоны доставки
      </h1>
      <LogisticTopMenu />
      <DeliveryZonesSubMenu />

      {error && (
        <Message
          showIcon
          type="error"
          header="При получении данных возникла ошибка!"
        >
          {error.message}
        </Message>
      )}

      <DeliveryZonesFilter 
        onFilterChanged={handleFilterChanged} 
        baseFilter={baseFilter}
      />

      <DeliveryZoneTable 
        brandSlug={brandSlug} 
        deliveryZones={deliveryZones}
        loading={loading}
        sortColumn={sort.fieldName}
        sortType={sort.direction === 0 ? 'desc' : 'asc'}
        onSortColumn={handleSortColumn}
        pageInfo={pageInfo}
      />


      {showPagination && (
        <Pagination
          size="md"
          last
          first
          next
          prev
          ellipsis
          activePage={page}
          pages={pageInfo?.lastPage}
          total={pageInfo?.lastPage ?? 1}
          maxButtons={10}
          onSelect={handlePageSelect}
        />
      )}
    </div>
  )
}